import { CashRegisterService } from "core/service";
import { CashRegisterPersistence } from "core/persistence";
import { CashRegister } from "core/entity";
import BaseRepository from "./base.repository";

class CashRegisterRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "cashRegister";
  }

  resourceName() {
    return "fechamentos de caixas";
  }

  getPersistenceProvider() {
    return CashRegisterPersistence;
  }

  getServiceProvider() {
    return CashRegisterService;
  }

  async modelToEntity(model) {
    const entity = new CashRegister({ ...model });
    return entity;
  }

  async getDocument(uuid) {
    return await this.mService.getDocument(uuid);
  }

  async getFile(uuid) {
    return await this.mService.getFile(uuid);
  }

  // async getLastUpdated(uuid) {
  //   return await this.mPersistence.lastUpdated('company_uuid', uuid, this.updatedAtField());
  // }

  updatedAtField() {
    return "opening_date";
  }
}

export default new CashRegisterRepository();



// WEBPACK FOOTER //
// ./src/core/repository/cash-register.repository.js